import { css } from "styled-components";
import breakpoints from "../../../styles/breakpoints";

export const infoBoxItemStyle = css`
  ${breakpoints.smUp} {
    display: block;
  }
`;

export const infoBoxItemDescriptionHolderStyle = css`
  ${breakpoints.mdUp} {
    padding: 20px 15px;
  }
`;

export const addWineToShoppingCartButtonStyle = css`
  ${breakpoints.smUp} {
    width: 100%;
  }
`;

export const infoBoxItemProductHolderButtonsStyle = css`
  ${breakpoints.smUp} {
    position: relative;
    display: block;
    top: 0;
  }
`;

export const infoBoxItemProductHolderStyle = css`
  ${breakpoints.smUp} {
    top: 0;
    width: 100%;
    position: relative;
  }
`;

export const infoBoxItemDescriptionWrapperStyle = css`
  ${breakpoints.smUp} {
    width: 100%;
  }
`;
